import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import avai from "../assets/avai.png";
import sicko from "../assets/sicko.png";
import aleph from "../assets/aleph.png";
import avax from "../assets/avalanche.svg";
import usdt from "../assets/USDT.png";
import usdc from "../assets/usdc.png";
import Hopepepe from "../assets/logo.png";
import {
  AVX_Address,
  HopePepe_Contract_Address,
  USDC_Contract_Address,
  USDT_Contract_Address,
} from "../utilies/constant";
import { Tokens } from "../Constant";

const TokenModal = ({
  isOpen,
  onClose,
  onSelectToken,
  activeButton,
  selectedFromToken,
  selectedToToken,
}) => {
  if (!isOpen) return null;


  const filteredTokens = Tokens.filter((token) => {
    if (activeButton === "from") {
      return token.symbol !== selectedToToken.name;
    } else {
      return token.symbol !== selectedFromToken.name;
    }
  });

  const handleTokenClick = (token) => {
    onSelectToken({ name: token.symbol, img: token.img,ContractAddress:token?.ContractAddress,type:token?.type });
  };
  return (
    <div className="fixed inset-0 flex items-center mx-4 justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg w-full lg:w-[500px] pb-6 shadow-lg">
        <div className="bg-[#f0f0ff] rounded-t-lg p-6">
          <div className="flex  justify-between items-center mb-4">
            <h2 className="text-[20px] font-[600]">Select a token</h2>
            <button
              onClick={onClose}
              className="text-gray-500 text-[20px] hover:text-gray-700"
            >
              <RxCross2 />
            </button>
          </div>
          <input
            type="text"
            placeholder="Search by name, symbol or address"
            className="w-full p-2 border border-gray-300 rounded-md mb-4"
          />
        </div>
        <div className="px-6">
          {filteredTokens.map((token, index) => (
            <div
              key={index}
              className="flex items-center p-2 hover:bg-gray-100 rounded-md cursor-pointer"
              onClick={() => handleTokenClick(token)}
            >
              <div className="w-10 h-10 bg-gray-200 rounded-full mr-3 flex items-center justify-center">
                <img
                  className="rounded-[99px] w-8 h-8"
                  src={token.img}
                  alt=""
                />
              </div>
              <div>
                <p className="font-medium">{token.symbol}</p>
                <p className="text-sm text-gray-500">{token.name}</p>
                <p className="text-xs text-gray-400">{token.category}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TokenModal;
